import VisualSlides from './VisualSlides';
import PeopleSlides from './PeopleSlides';
import StoriesSlides from './StoriesSlides';
import ParticlesBg from './ParticlesBg';
// import VideoController from './VideoController';

export default class {
  constructor() {

    const VisualSlidesDom = document.querySelector('[data-js="visual-slide"]');
    if (VisualSlidesDom) new VisualSlides(VisualSlidesDom);

    const PeopleSlidesDom = document.querySelector('[data-js="people-slide"]');
    if (PeopleSlidesDom) new PeopleSlides(PeopleSlidesDom);

    const StoriesSlidesDom = document.querySelector('[data-js="stories-slide"]');
    if (StoriesSlidesDom) new StoriesSlides(StoriesSlidesDom);

    const ParticlesBgDom = document.querySelectorAll('[data-js="particles"]');
    // new ParticlesBg(ParticlesBgDom);
    if (ParticlesBgDom) {
      [...ParticlesBgDom].forEach((el) => {
        new ParticlesBg(el);
      })
    }

    // const VideoControllerDom = document.querySelector('[data-js="video"]');
    // if (VideoControllerDom) new VideoController(VideoControllerDom);
  }
}
